'use client';

import { useSearchParams } from 'next/navigation';

import { BlockClassyFragment } from '~/server/generated/contentful-graphql';

export function ClassyIframeBlock({
  block,
  utmCampaign,
  utmMedium,
}: {
  block: Pick<BlockClassyFragment, 'campaignId' | 'headline' | 'recurringNudges'>;
  utmCampaign?: string;
  utmMedium?: string;
}) {
  const searchParams = useSearchParams();

  // Use provided props first, then fall back to URL search params, then defaults
  const cSrc = utmMedium || searchParams.get('utm_medium') || 'web';
  const cSrc2 = utmCampaign || searchParams.get('utm_campaign') || 'block-classy';

  const src = `https://donate.starlight.org/give/${block.campaignId}#!/donation/checkout?eg=true${
    block.recurringNudges && '&egrn=true'
  }&c_src=${cSrc}&c_src2=${cSrc2}`;

  return (
    <div className='mx-auto max-w-[384px] rounded-2xl md:pb-4 lg:w-full lg:max-w-sm lg:bg-white [&_iframe]:h-[520px] xl:[&_iframe]:h-[600px]'>
      <iframe
        // @ts-ignore
        // eslint-disable-next-line react/no-unknown-property
        allowpaymentrequest='true'
        className='w-full rounded-2xl'
        height='600'
        scrolling='no'
        src={src}
        title={block.headline ? block.headline : 'Make a Donation'}
      />
    </div>
  );
}
